// // import React, { useState } from "react";
// // import { Button, Form, Grid, Input, message, Spin, theme } from "antd";
// // import { LockOutlined, SyncOutlined, UserOutlined } from "@ant-design/icons";
// // import { Link, Navigate, useNavigate } from "react-router-dom";
// // import Cookies from "js-cookie";
// // import { logIn } from "../Service/login";

// // const { useToken } = theme;
// // const { useBreakpoint } = Grid;

// // export default function Login() {
// //   const navigate = useNavigate();
// //   const { token } = useToken();
// //   const screens = useBreakpoint();

// //   const [isLoading, setIsLoading] = useState(false);
// //   const [messageApi, contextHolder] = message.useMessage();

// //   const onFinish = (values) => {
// //     setIsLoading(true);
// //     logIn(values)
// //       .then((res) => {
// //         if (res.status === 200) {
// //           navigate(`/login-otp/${values.email}`, { replace: true });
// //         }
// //       })
// //       .catch((err) => {
// //         const msg =
// //           err.response?.data?.message || err.message || "Server error";
// //         messageApi.open({
// //           type: "error",
// //           content: msg,
// //         });
// //       })
// //       .finally(() => setIsLoading(false));
// //   };

// //   const userDetails = Cookies.get("user_details");

// //   const styles = {
// //     section: {
// //       minHeight: "100vh",
// //       display: "flex",
// //       flexDirection: "column",
// //       justifyContent: "center", // vertical centering
// //       alignItems: "flex-end", // 👈 push card to the right
// //       background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",

// //       // 👇 SAME logic as old code
// //       padding: screens.md ? `${token.sizeXXL}px 60px` : "10px",
// //     },

// //     container: {
// //       // background: "#ffffff",
// //       background: "rgba(255, 255, 255)",
// //       borderRadius: "12px",
// //       boxShadow: "0 10px 40px rgba(0, 0, 0, 0.1)",
// //       padding: "40px",
// //       width: "420px", // fixed width is important
// //     },

// //     header: {
// //       textAlign: "center",
// //       marginBottom: "32px",
// //     },

// //     title: {
// //       fontSize: "28px",
// //       fontWeight: 700,
// //       color: "#1a202c",
// //       marginBottom: "8px",
// //     },

// //     subtitle: {
// //       fontSize: "14px",
// //       color: "#718096",
// //     },

// //     label: {
// //       fontSize: "14px",
// //       fontWeight: 600,
// //       color: "#2d3748",
// //     },

// //     input: {
// //       padding: "12px 16px",
// //       borderRadius: "8px",
// //       fontSize: "16px",
// //     },

// //     button: {
// //       height: "48px",
// //       fontSize: "16px",
// //       fontWeight: 600,
// //       borderRadius: "8px",
// //       background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
// //       border: "none",
// //     },

// //     forgotPassword: {
// //       marginTop: "16px",
// //       textAlign: "center",
// //       display: "block",
// //       color: "#667eea",
// //       fontSize: "14px",
// //       fontWeight: 500,
// //     },
// //   };

// //   return userDetails ? (
// //     <Navigate to="/" replace />
// //   ) : (
// //     <>
// //       {contextHolder}
// //       <section
// //         style={{
// //           ...styles.section,
// //           backgroundImage: `url(${process.env.PUBLIC_URL}/images/home_page_image.png)`,
// //         }}
// //       >
// //         <div style={styles.container}>
// //           {/* Header */}
// //           <div style={styles.header}>
// //             {/* <h2 style={styles.title}>Sign In</h2> */}
// //             <div
// //               style={{
// //                 textAlign: "center",
// //                 display: "flex",
// //                 width: "100%",
// //                 justifyContent: "center",
// //                 alignItems: "center",
// //               }}
// //             >
// //               <img
// //                 src={`${process.env.PUBLIC_URL}/images/step_to_innovation_logo.jpeg`}
// //                 alt="Logo"
// //                 style={{
// //                   width: "5rem",
// //                   height: "auto",
// //                   borderRadius: "50%",
// //                   marginRight: "10px",
// //                 }}
// //               />
// //               <h2>Step to Innovation</h2>
// //             </div>
// //             <p style={styles.subtitle}>
// //               Enter your credentials to login your account
// //             </p>
// //           </div>

// //           {/* Login Form */}
// //           <Form
// //             name="login_form"
// //             layout="vertical"
// //             requiredMark={false}
// //             onFinish={onFinish}
// //           >
// //             <Form.Item
// //               name="email"
// //               label={<span style={styles.label}>Email Address</span>}
// //               rules={[{ required: true, message: "Please input your email!" }]}
// //             >
// //               <Input
// //                 prefix={<UserOutlined />}
// //                 placeholder="Enter your email"
// //                 style={styles.input}
// //               />
// //             </Form.Item>

// //             <Form.Item
// //               name="password"
// //               label={<span style={styles.label}>Password</span>}
// //               rules={[
// //                 { required: true, message: "Please input your password!" },
// //               ]}
// //             >
// //               <Input.Password
// //                 prefix={<LockOutlined />}
// //                 placeholder="Enter your password"
// //                 style={styles.input}
// //               />
// //             </Form.Item>

// //             <Form.Item style={{ marginBottom: 0 }}>
// //               <Button
// //                 block
// //                 type="primary"
// //                 htmlType="submit"
// //                 style={styles.button}
// //                 disabled={isLoading}
// //                 icon={
// //                   isLoading ? (
// //                     <Spin
// //                       indicator={<SyncOutlined spin />}
// //                       style={{ color: "white" }}
// //                     />
// //                   ) : null
// //                 }
// //               >
// //                 {!isLoading && "Sign In"}
// //               </Button>
// //             </Form.Item>

// //             <Link to="/forget-password" style={styles.forgotPassword}>
// //               Forgot Password?
// //             </Link>
// //           </Form>
// //         </div>
// //       </section>
// //     </>
// //   );
// // }

// // above is with OTP login

// // below is without OTP login

// import React, { useState } from "react";
// import { Button, Form, Grid, Input, message, Spin, theme } from "antd";
// import { LockOutlined, SyncOutlined, UserOutlined } from "@ant-design/icons";
// import { Link, Navigate, useNavigate } from "react-router-dom";
// import Cookies from "js-cookie";
// import { logIn } from "../Service/login";
// import { usePermissions } from "../../context/PermissionContext";
// import { encryptAES } from "../../utils/crypto";

// const { useToken } = theme;
// const { useBreakpoint } = Grid;

// export default function Login() {
//   const navigate = useNavigate();
//   const { token } = useToken();
//   const screens = useBreakpoint();
//   const { reload } = usePermissions();

//   const [isLoading, setIsLoading] = useState(false);
//   const [messageApi, contextHolder] = message.useMessage();

//   const onFinish = async (values) => {
//     setIsLoading(true);
//     try {
//       // Encrypt the password with AES-CBC before sending —
//       // backend CryptoService.decrypt() expects: base64(iv):base64(ciphertext)
//       const encryptedPassword = await encryptAES(values.password);

//       const res = await logIn({ ...values, password: encryptedPassword });

//       // 1. Write cookies
//       const AUTH_TOKEN_EXPIRY    = new Date(Date.now() + 10 * 60 * 1000); // 10 min
//       const REFRESH_TOKEN_EXPIRY = new Date(Date.now() + 30 * 60 * 1000); // 30 min

//       Cookies.set("AUTH_TOKEN",    JSON.stringify(res.data.accessToken),  { expires: AUTH_TOKEN_EXPIRY });
//       Cookies.set("REFRESH_TOKEN", JSON.stringify(res.data.refreshToken), { expires: REFRESH_TOKEN_EXPIRY });
//       Cookies.set("user_details",  JSON.stringify(res.data.userDetails),  { expires: REFRESH_TOKEN_EXPIRY });

//       // 2. Load permissions before navigating
//       await reload();

//       // 3. Navigate
//       navigate("/", { replace: true });
//     } catch (err) {
//       const msg = err.response?.data?.message || err.message || "Server error";
//       messageApi.open({ type: "error", content: msg });
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const userDetails = Cookies.get("user_details");

//   const styles = {
//     section: {
//       minHeight: "100vh",
//       display: "flex",
//       flexDirection: "column",
//       justifyContent: "center",
//       alignItems: "flex-end",
//       background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
//       padding: screens.md ? `${token.sizeXXL}px 60px` : "10px",
//     },
//     container: {
//       background: "rgba(255, 255, 255)",
//       borderRadius: "12px",
//       boxShadow: "0 10px 40px rgba(0, 0, 0, 0.1)",
//       padding: "40px",
//       width: "420px",
//     },
//     header: {
//       textAlign: "center",
//       marginBottom: "32px",
//     },
//     title: {
//       fontSize: "28px",
//       fontWeight: 700,
//       color: "#1a202c",
//       marginBottom: "8px",
//     },
//     subtitle: {
//       fontSize: "14px",
//       color: "#718096",
//     },
//     label: {
//       fontSize: "14px",
//       fontWeight: 600,
//       color: "#2d3748",
//     },
//     input: {
//       padding: "12px 16px",
//       borderRadius: "8px",
//       fontSize: "16px",
//     },
//     button: {
//       height: "48px",
//       fontSize: "16px",
//       fontWeight: 600,
//       borderRadius: "8px",
//       background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
//       border: "none",
//     },
//     forgotPassword: {
//       marginTop: "16px",
//       textAlign: "center",
//       display: "block",
//       color: "#667eea",
//       fontSize: "14px",
//       fontWeight: 500,
//     },
//   };

//   return userDetails ? (
//     <Navigate to="/" replace />
//   ) : (
//     <>
//       {contextHolder}
//       <section
//         style={{
//           ...styles.section,
//           backgroundImage: `url(${process.env.PUBLIC_URL}/images/home_page_image.png)`,
//         }}
//       >
//         <div style={styles.container}>
//           {/* Header */}
//           <div style={styles.header}>
//             <div
//               style={{
//                 textAlign: "center",
//                 display: "flex",
//                 width: "100%",
//                 justifyContent: "center",
//                 alignItems: "center",
//               }}
//             >
//               <img
//                 src={`${process.env.PUBLIC_URL}/images/step_to_innovation_logo.jpeg`}
//                 alt="Logo"
//                 style={{
//                   width: "5rem",
//                   height: "auto",
//                   borderRadius: "50%",
//                   marginRight: "10px",
//                 }}
//               />
//               <h2>Step to Innovation</h2>
//             </div>
//             <p style={styles.subtitle}>
//               Enter your credentials to login your account
//             </p>
//           </div>

//           {/* Login Form */}
//           <Form
//             name="login_form"
//             layout="vertical"
//             requiredMark={false}
//             onFinish={onFinish}
//           >
//             <Form.Item
//               name="email"
//               label={<span style={styles.label}>Email Address</span>}
//               rules={[{ required: true, message: "Please input your email!" }]}
//             >
//               <Input
//                 prefix={<UserOutlined />}
//                 placeholder="Enter your email"
//                 style={styles.input}
//               />
//             </Form.Item>

//             <Form.Item
//               name="password"
//               label={<span style={styles.label}>Password</span>}
//               rules={[{ required: true, message: "Please input your password!" }]}
//             >
//               <Input.Password
//                 prefix={<LockOutlined />}
//                 placeholder="Enter your password"
//                 style={styles.input}
//               />
//             </Form.Item>

//             <Form.Item style={{ marginBottom: 0 }}>
//               <Button
//                 block
//                 type="primary"
//                 htmlType="submit"
//                 style={styles.button}
//                 disabled={isLoading}
//                 icon={
//                   isLoading ? (
//                     <Spin
//                       indicator={<SyncOutlined spin />}
//                       style={{ color: "white" }}
//                     />
//                   ) : null
//                 }
//               >
//                 {!isLoading && "Sign In"}
//               </Button>
//             </Form.Item>

//             <Link to="/forget-password" style={styles.forgotPassword}>
//               Forgot Password?
//             </Link>
//           </Form>
//         </div>
//       </section>
//     </>
//   );
// }

// // import React, { useState } from "react";
// // import { Button, Form, Grid, Input, message, Spin, theme } from "antd";
// // import { LockOutlined, SyncOutlined, UserOutlined } from "@ant-design/icons";
// // import { Link, Navigate, useNavigate } from "react-router-dom";
// // import Cookies from "js-cookie";
// // import { logIn } from "../Service/login";

// // const { useToken } = theme;
// // const { useBreakpoint } = Grid;

// // export default function Login() {
// //   const navigate = useNavigate();
// //   const { token } = useToken();
// //   const screens = useBreakpoint();

// //   const [isLoading, setIsLoading] = useState(false);
// //   const [messageApi, contextHolder] = message.useMessage();

// //   const onFinish = (values) => {
// //     setIsLoading(true);
// //     logIn(values)
// //       .then((res) => {
// //         if (res.status === 200) {
// //           navigate(`/login-otp/${values.email}`, { replace: true });
// //         }
// //       })
// //       .catch((err) => {
// //         const msg =
// //           err.response?.data?.message || err.message || "Server error";
// //         messageApi.open({
// //           type: "error",
// //           content: msg,
// //         });
// //       })
// //       .finally(() => setIsLoading(false));
// //   };

// //   const userDetails = Cookies.get("user_details");

// //   const styles = {
// //     section: {
// //       minHeight: "100vh",
// //       display: "flex",
// //       flexDirection: "column",
// //       justifyContent: "center", // vertical centering
// //       alignItems: "flex-end", // 👈 push card to the right
// //       background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",

// //       // 👇 SAME logic as old code
// //       padding: screens.md ? `${token.sizeXXL}px 60px` : "10px",
// //     },

// //     container: {
// //       // background: "#ffffff",
// //       background: "rgba(255, 255, 255)",
// //       borderRadius: "12px",
// //       boxShadow: "0 10px 40px rgba(0, 0, 0, 0.1)",
// //       padding: "40px",
// //       width: "420px", // fixed width is important
// //     },

// //     header: {
// //       textAlign: "center",
// //       marginBottom: "32px",
// //     },

// //     title: {
// //       fontSize: "28px",
// //       fontWeight: 700,
// //       color: "#1a202c",
// //       marginBottom: "8px",
// //     },

// //     subtitle: {
// //       fontSize: "14px",
// //       color: "#718096",
// //     },

// //     label: {
// //       fontSize: "14px",
// //       fontWeight: 600,
// //       color: "#2d3748",
// //     },

// //     input: {
// //       padding: "12px 16px",
// //       borderRadius: "8px",
// //       fontSize: "16px",
// //     },

// //     button: {
// //       height: "48px",
// //       fontSize: "16px",
// //       fontWeight: 600,
// //       borderRadius: "8px",
// //       background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
// //       border: "none",
// //     },

// //     forgotPassword: {
// //       marginTop: "16px",
// //       textAlign: "center",
// //       display: "block",
// //       color: "#667eea",
// //       fontSize: "14px",
// //       fontWeight: 500,
// //     },
// //   };

// //   return userDetails ? (
// //     <Navigate to="/" replace />
// //   ) : (
// //     <>
// //       {contextHolder}
// //       <section
// //         style={{
// //           ...styles.section,
// //           backgroundImage: `url(${process.env.PUBLIC_URL}/images/home_page_image.png)`,
// //         }}
// //       >
// //         <div style={styles.container}>
// //           {/* Header */}
// //           <div style={styles.header}>
// //             {/* <h2 style={styles.title}>Sign In</h2> */}
// //             <div
// //               style={{
// //                 textAlign: "center",
// //                 display: "flex",
// //                 width: "100%",
// //                 justifyContent: "center",
// //                 alignItems: "center",
// //               }}
// //             >
// //               <img
// //                 src={`${process.env.PUBLIC_URL}/images/step_to_innovation_logo.jpeg`}
// //                 alt="Logo"
// //                 style={{
// //                   width: "5rem",
// //                   height: "auto",
// //                   borderRadius: "50%",
// //                   marginRight: "10px",
// //                 }}
// //               />
// //               <h2>Step to Innovation</h2>
// //             </div>
// //             <p style={styles.subtitle}>
// //               Enter your credentials to login your account
// //             </p>
// //           </div>

// //           {/* Login Form */}
// //           <Form
// //             name="login_form"
// //             layout="vertical"
// //             requiredMark={false}
// //             onFinish={onFinish}
// //           >
// //             <Form.Item
// //               name="email"
// //               label={<span style={styles.label}>Email Address</span>}
// //               rules={[{ required: true, message: "Please input your email!" }]}
// //             >
// //               <Input
// //                 prefix={<UserOutlined />}
// //                 placeholder="Enter your email"
// //                 style={styles.input}
// //               />
// //             </Form.Item>

// //             <Form.Item
// //               name="password"
// //               label={<span style={styles.label}>Password</span>}
// //               rules={[
// //                 { required: true, message: "Please input your password!" },
// //               ]}
// //             >
// //               <Input.Password
// //                 prefix={<LockOutlined />}
// //                 placeholder="Enter your password"
// //                 style={styles.input}
// //               />
// //             </Form.Item>

// //             <Form.Item style={{ marginBottom: 0 }}>
// //               <Button
// //                 block
// //                 type="primary"
// //                 htmlType="submit"
// //                 style={styles.button}
// //                 disabled={isLoading}
// //                 icon={
// //                   isLoading ? (
// //                     <Spin
// //                       indicator={<SyncOutlined spin />}
// //                       style={{ color: "white" }}
// //                     />
// //                   ) : null
// //                 }
// //               >
// //                 {!isLoading && "Sign In"}
// //               </Button>
// //             </Form.Item>

// //             <Link to="/forget-password" style={styles.forgotPassword}>
// //               Forgot Password?
// //             </Link>
// //           </Form>
// //         </div>
// //       </section>
// //     </>
// //   );
// // }

// // above is with OTP login

// // below is without OTP login

// import React, { useState } from "react";
// import { Button, Form, Grid, Input, message, Spin, theme } from "antd";
// import { LockOutlined, SyncOutlined, UserOutlined } from "@ant-design/icons";
// import { Link, Navigate, useNavigate } from "react-router-dom";
// import Cookies from "js-cookie";
// import { logIn } from "../Service/login";
// import { usePermissions } from "../../context/PermissionContext";
// import { encryptAES } from "../../utils/crypto";

// const { useToken } = theme;
// const { useBreakpoint } = Grid;

// export default function Login() {
//   const navigate = useNavigate();
//   const { token } = useToken();
//   const screens = useBreakpoint();
//   const { reload } = usePermissions();

//   const [isLoading, setIsLoading] = useState(false);
//   const [messageApi, contextHolder] = message.useMessage();

//   const onFinish = async (values) => {
//     setIsLoading(true);
//     try {
//       // Encrypt the password with AES-CBC before sending —
//       // backend CryptoService.decrypt() expects: base64(iv):base64(ciphertext)
//       const encryptedPassword = await encryptAES(values.password);

//       const res = await logIn({ ...values, password: encryptedPassword });

//       // 1. Write cookies
//       const AUTH_TOKEN_EXPIRY    = new Date(Date.now() + 10 * 60 * 1000); // 10 min
//       const REFRESH_TOKEN_EXPIRY = new Date(Date.now() + 30 * 60 * 1000); // 30 min

//       Cookies.set("AUTH_TOKEN",    JSON.stringify(res.data.accessToken),  { expires: AUTH_TOKEN_EXPIRY });
//       Cookies.set("REFRESH_TOKEN", JSON.stringify(res.data.refreshToken), { expires: REFRESH_TOKEN_EXPIRY });
//       Cookies.set("user_details",  JSON.stringify(res.data.userDetails),  { expires: REFRESH_TOKEN_EXPIRY });

//       // 2. Load permissions before navigating
//       await reload();

//       // 3. Navigate
//       navigate("/", { replace: true });
//     } catch (err) {
//       const msg = err.response?.data?.message || err.message || "Server error";
//       messageApi.open({ type: "error", content: msg });
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const userDetails = Cookies.get("user_details");

//   const styles = {
//     section: {
//       minHeight: "100vh",
//       display: "flex",
//       flexDirection: "column",
//       justifyContent: "center",
//       alignItems: "flex-end",
//       background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
//       padding: screens.md ? `${token.sizeXXL}px 60px` : "10px",
//     },
//     container: {
//       background: "rgba(255, 255, 255)",
//       borderRadius: "12px",
//       boxShadow: "0 10px 40px rgba(0, 0, 0, 0.1)",
//       padding: "40px",
//       width: "420px",
//     },
//     header: {
//       textAlign: "center",
//       marginBottom: "32px",
//     },
//     title: {
//       fontSize: "28px",
//       fontWeight: 700,
//       color: "#1a202c",
//       marginBottom: "8px",
//     },
//     subtitle: {
//       fontSize: "14px",
//       color: "#718096",
//     },
//     label: {
//       fontSize: "14px",
//       fontWeight: 600,
//       color: "#2d3748",
//     },
//     input: {
//       padding: "12px 16px",
//       borderRadius: "8px",
//       fontSize: "16px",
//     },
//     button: {
//       height: "48px",
//       fontSize: "16px",
//       fontWeight: 600,
//       borderRadius: "8px",
//       background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
//       border: "none",
//     },
//     forgotPassword: {
//       marginTop: "16px",
//       textAlign: "center",
//       display: "block",
//       color: "#667eea",
//       fontSize: "14px",
//       fontWeight: 500,
//     },
//   };

//   return userDetails ? (
//     <Navigate to="/" replace />
//   ) : (
//     <>
//       {contextHolder}
//       <section
//         style={{
//           ...styles.section,
//           backgroundImage: `url(${process.env.PUBLIC_URL}/images/home_page_image.png)`,
//         }}
//       >
//         <div style={styles.container}>
//           {/* Header */}
//           <div style={styles.header}>
//             <div
//               style={{
//                 textAlign: "center",
//                 display: "flex",
//                 width: "100%",
//                 justifyContent: "center",
//                 alignItems: "center",
//               }}
//             >
//               <img
//                 src={`${process.env.PUBLIC_URL}/images/step_to_innovation_logo.jpeg`}
//                 alt="Logo"
//                 style={{
//                   width: "5rem",
//                   height: "auto",
//                   borderRadius: "50%",
//                   marginRight: "10px",
//                 }}
//               />
//               <h2>Step to Innovation</h2>
//             </div>
//             <p style={styles.subtitle}>
//               Enter your credentials to login your account
//             </p>
//           </div>

//           {/* Login Form */}
//           <Form
//             name="login_form"
//             layout="vertical"
//             requiredMark={false}
//             onFinish={onFinish}
//           >
//             <Form.Item
//               name="email"
//               label={<span style={styles.label}>Email Address</span>}
//               rules={[{ required: true, message: "Please input your email!" }]}
//             >
//               <Input
//                 prefix={<UserOutlined />}
//                 placeholder="Enter your email"
//                 style={styles.input}
//               />
//             </Form.Item>

//             <Form.Item
//               name="password"
//               label={<span style={styles.label}>Password</span>}
//               rules={[{ required: true, message: "Please input your password!" }]}
//             >
//               <Input.Password
//                 prefix={<LockOutlined />}
//                 placeholder="Enter your password"
//                 style={styles.input}
//               />
//             </Form.Item>

//             <Form.Item style={{ marginBottom: 0 }}>
//               <Button
//                 block
//                 type="primary"
//                 htmlType="submit"
//                 style={styles.button}
//                 disabled={isLoading}
//                 icon={
//                   isLoading ? (
//                     <Spin
//                       indicator={<SyncOutlined spin />}
//                       style={{ color: "white" }}
//                     />
//                   ) : null
//                 }
//               >
//                 {!isLoading && "Sign In"}
//               </Button>
//             </Form.Item>

//             <Link to="/forget-password" style={styles.forgotPassword}>
//               Forgot Password?
//             </Link>
//           </Form>
//         </div>
//       </section>
//     </>
//   );
// }

// // import React, { useState } from "react";
// // import { Button, Form, Grid, Input, message, Spin, theme } from "antd";
// // import { LockOutlined, SyncOutlined, UserOutlined } from "@ant-design/icons";
// // import { Link, Navigate, useNavigate } from "react-router-dom";
// // import Cookies from "js-cookie";
// // import { logIn } from "../Service/login";

// // const { useToken } = theme;
// // const { useBreakpoint } = Grid;

// // export default function Login() {
// //   const navigate = useNavigate();
// //   const { token } = useToken();
// //   const screens = useBreakpoint();

// //   const [isLoading, setIsLoading] = useState(false);
// //   const [messageApi, contextHolder] = message.useMessage();

// //   const onFinish = (values) => {
// //     setIsLoading(true);
// //     logIn(values)
// //       .then((res) => {
// //         if (res.status === 200) {
// //           navigate(`/login-otp/${values.email}`, { replace: true });
// //         }
// //       })
// //       .catch((err) => {
// //         const msg =
// //           err.response?.data?.message || err.message || "Server error";
// //         messageApi.open({
// //           type: "error",
// //           content: msg,
// //         });
// //       })
// //       .finally(() => setIsLoading(false));
// //   };

// //   const userDetails = Cookies.get("user_details");

// //   const styles = {
// //     section: {
// //       minHeight: "100vh",
// //       display: "flex",
// //       flexDirection: "column",
// //       justifyContent: "center", // vertical centering
// //       alignItems: "flex-end", // 👈 push card to the right
// //       background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",

// //       // 👇 SAME logic as old code
// //       padding: screens.md ? `${token.sizeXXL}px 60px` : "10px",
// //     },

// //     container: {
// //       // background: "#ffffff",
// //       background: "rgba(255, 255, 255)",
// //       borderRadius: "12px",
// //       boxShadow: "0 10px 40px rgba(0, 0, 0, 0.1)",
// //       padding: "40px",
// //       width: "420px", // fixed width is important
// //     },

// //     header: {
// //       textAlign: "center",
// //       marginBottom: "32px",
// //     },

// //     title: {
// //       fontSize: "28px",
// //       fontWeight: 700,
// //       color: "#1a202c",
// //       marginBottom: "8px",
// //     },

// //     subtitle: {
// //       fontSize: "14px",
// //       color: "#718096",
// //     },

// //     label: {
// //       fontSize: "14px",
// //       fontWeight: 600,
// //       color: "#2d3748",
// //     },

// //     input: {
// //       padding: "12px 16px",
// //       borderRadius: "8px",
// //       fontSize: "16px",
// //     },

// //     button: {
// //       height: "48px",
// //       fontSize: "16px",
// //       fontWeight: 600,
// //       borderRadius: "8px",
// //       background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
// //       border: "none",
// //     },

// //     forgotPassword: {
// //       marginTop: "16px",
// //       textAlign: "center",
// //       display: "block",
// //       color: "#667eea",
// //       fontSize: "14px",
// //       fontWeight: 500,
// //     },
// //   };

// //   return userDetails ? (
// //     <Navigate to="/" replace />
// //   ) : (
// //     <>
// //       {contextHolder}
// //       <section
// //         style={{
// //           ...styles.section,
// //           backgroundImage: `url(${process.env.PUBLIC_URL}/images/home_page_image.png)`,
// //         }}
// //       >
// //         <div style={styles.container}>
// //           {/* Header */}
// //           <div style={styles.header}>
// //             {/* <h2 style={styles.title}>Sign In</h2> */}
// //             <div
// //               style={{
// //                 textAlign: "center",
// //                 display: "flex",
// //                 width: "100%",
// //                 justifyContent: "center",
// //                 alignItems: "center",
// //               }}
// //             >
// //               <img
// //                 src={`${process.env.PUBLIC_URL}/images/step_to_innovation_logo.jpeg`}
// //                 alt="Logo"
// //                 style={{
// //                   width: "5rem",
// //                   height: "auto",
// //                   borderRadius: "50%",
// //                   marginRight: "10px",
// //                 }}
// //               />
// //               <h2>Step to Innovation</h2>
// //             </div>
// //             <p style={styles.subtitle}>
// //               Enter your credentials to login your account
// //             </p>
// //           </div>

// //           {/* Login Form */}
// //           <Form
// //             name="login_form"
// //             layout="vertical"
// //             requiredMark={false}
// //             onFinish={onFinish}
// //           >
// //             <Form.Item
// //               name="email"
// //               label={<span style={styles.label}>Email Address</span>}
// //               rules={[{ required: true, message: "Please input your email!" }]}
// //             >
// //               <Input
// //                 prefix={<UserOutlined />}
// //                 placeholder="Enter your email"
// //                 style={styles.input}
// //               />
// //             </Form.Item>

// //             <Form.Item
// //               name="password"
// //               label={<span style={styles.label}>Password</span>}
// //               rules={[
// //                 { required: true, message: "Please input your password!" },
// //               ]}
// //             >
// //               <Input.Password
// //                 prefix={<LockOutlined />}
// //                 placeholder="Enter your password"
// //                 style={styles.input}
// //               />
// //             </Form.Item>

// //             <Form.Item style={{ marginBottom: 0 }}>
// //               <Button
// //                 block
// //                 type="primary"
// //                 htmlType="submit"
// //                 style={styles.button}
// //                 disabled={isLoading}
// //                 icon={
// //                   isLoading ? (
// //                     <Spin
// //                       indicator={<SyncOutlined spin />}
// //                       style={{ color: "white" }}
// //                     />
// //                   ) : null
// //                 }
// //               >
// //                 {!isLoading && "Sign In"}
// //               </Button>
// //             </Form.Item>

// //             <Link to="/forget-password" style={styles.forgotPassword}>
// //               Forgot Password?
// //             </Link>
// //           </Form>
// //         </div>
// //       </section>
// //     </>
// //   );
// // }

// // above is with OTP login

// // below is without OTP login

// import React, { useState } from "react";
// import { Button, Form, Grid, Input, message, Spin, theme } from "antd";
// import { LockOutlined, SyncOutlined, UserOutlined } from "@ant-design/icons";
// import { Link, Navigate, useNavigate } from "react-router-dom";
// import Cookies from "js-cookie";
// import { logIn } from "../Service/login";
// import { usePermissions } from "../../context/PermissionContext";
// import { encryptAES } from "../../utils/crypto";

// const { useToken } = theme;
// const { useBreakpoint } = Grid;

// export default function Login() {
//   const navigate = useNavigate();
//   const { token } = useToken();
//   const screens = useBreakpoint();
//   const { reload } = usePermissions();

//   const [isLoading, setIsLoading] = useState(false);
//   const [messageApi, contextHolder] = message.useMessage();

//   const onFinish = async (values) => {
//     setIsLoading(true);
//     try {
//       // Encrypt the password with AES-CBC before sending —
//       // backend CryptoService.decrypt() expects: base64(iv):base64(ciphertext)
//       const encryptedPassword = await encryptAES(values.password);

//       const res = await logIn({ ...values, password: encryptedPassword });

//       // 1. Write cookies
//       const AUTH_TOKEN_EXPIRY    = new Date(Date.now() + 10 * 60 * 1000); // 10 min
//       const REFRESH_TOKEN_EXPIRY = new Date(Date.now() + 30 * 60 * 1000); // 30 min

//       Cookies.set("AUTH_TOKEN",    JSON.stringify(res.data.accessToken),  { expires: AUTH_TOKEN_EXPIRY });
//       Cookies.set("REFRESH_TOKEN", JSON.stringify(res.data.refreshToken), { expires: REFRESH_TOKEN_EXPIRY });
//       Cookies.set("user_details",  JSON.stringify(res.data.userDetails),  { expires: REFRESH_TOKEN_EXPIRY });

//       // 2. Load permissions before navigating
//       await reload();

//       // 3. Navigate
//       navigate("/", { replace: true });
//     } catch (err) {
//       const msg = err.response?.data?.message || err.message || "Server error";
//       messageApi.open({ type: "error", content: msg });
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const userDetails = Cookies.get("user_details");

//   const styles = {
//     section: {
//       minHeight: "100vh",
//       display: "flex",
//       flexDirection: "column",
//       justifyContent: "center",
//       alignItems: "flex-end",
//       background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
//       padding: screens.md ? `${token.sizeXXL}px 60px` : "10px",
//     },
//     container: {
//       background: "rgba(255, 255, 255)",
//       borderRadius: "12px",
//       boxShadow: "0 10px 40px rgba(0, 0, 0, 0.1)",
//       padding: "40px",
//       width: "420px",
//     },
//     header: {
//       textAlign: "center",
//       marginBottom: "32px",
//     },
//     title: {
//       fontSize: "28px",
//       fontWeight: 700,
//       color: "#1a202c",
//       marginBottom: "8px",
//     },
//     subtitle: {
//       fontSize: "14px",
//       color: "#718096",
//     },
//     label: {
//       fontSize: "14px",
//       fontWeight: 600,
//       color: "#2d3748",
//     },
//     input: {
//       padding: "12px 16px",
//       borderRadius: "8px",
//       fontSize: "16px",
//     },
//     button: {
//       height: "48px",
//       fontSize: "16px",
//       fontWeight: 600,
//       borderRadius: "8px",
//       background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
//       border: "none",
//     },
//     forgotPassword: {
//       marginTop: "16px",
//       textAlign: "center",
//       display: "block",
//       color: "#667eea",
//       fontSize: "14px",
//       fontWeight: 500,
//     },
//   };

//   return userDetails ? (
//     <Navigate to="/" replace />
//   ) : (
//     <>
//       {contextHolder}
//       <section
//         style={{
//           ...styles.section,
//           backgroundImage: `url(${process.env.PUBLIC_URL}/images/home_page_image.png)`,
//         }}
//       >
//         <div style={styles.container}>
//           {/* Header */}
//           <div style={styles.header}>
//             <div
//               style={{
//                 textAlign: "center",
//                 display: "flex",
//                 width: "100%",
//                 justifyContent: "center",
//                 alignItems: "center",
//               }}
//             >
//               <img
//                 src={`${process.env.PUBLIC_URL}/images/step_to_innovation_logo.jpeg`}
//                 alt="Logo"
//                 style={{
//                   width: "5rem",
//                   height: "auto",
//                   borderRadius: "50%",
//                   marginRight: "10px",
//                 }}
//               />
//               <h2>Step to Innovation</h2>
//             </div>
//             <p style={styles.subtitle}>
//               Enter your credentials to login your account
//             </p>
//           </div>

//           {/* Login Form */}
//           <Form
//             name="login_form"
//             layout="vertical"
//             requiredMark={false}
//             onFinish={onFinish}
//           >
//             <Form.Item
//               name="email"
//               label={<span style={styles.label}>Email Address</span>}
//               rules={[{ required: true, message: "Please input your email!" }]}
//             >
//               <Input
//                 prefix={<UserOutlined />}
//                 placeholder="Enter your email"
//                 style={styles.input}
//               />
//             </Form.Item>

//             <Form.Item
//               name="password"
//               label={<span style={styles.label}>Password</span>}
//               rules={[{ required: true, message: "Please input your password!" }]}
//             >
//               <Input.Password
//                 prefix={<LockOutlined />}
//                 placeholder="Enter your password"
//                 style={styles.input}
//               />
//             </Form.Item>

//             <Form.Item style={{ marginBottom: 0 }}>
//               <Button
//                 block
//                 type="primary"
//                 htmlType="submit"
//                 style={styles.button}
//                 disabled={isLoading}
//                 icon={
//                   isLoading ? (
//                     <Spin
//                       indicator={<SyncOutlined spin />}
//                       style={{ color: "white" }}
//                     />
//                   ) : null
//                 }
//               >
//                 {!isLoading && "Sign In"}
//               </Button>
//             </Form.Item>

//             <Link to="/forget-password" style={styles.forgotPassword}>
//               Forgot Password?
//             </Link>
//           </Form>
//         </div>
//       </section>
//     </>
//   );
// }

// // import React, { useState } from "react";
// // import { Button, Form, Grid, Input, message, Spin, theme } from "antd";
// // import { LockOutlined, SyncOutlined, UserOutlined } from "@ant-design/icons";
// // import { Link, Navigate, useNavigate } from "react-router-dom";
// // import Cookies from "js-cookie";
// // import { logIn } from "../Service/login";

// // const { useToken } = theme;
// // const { useBreakpoint } = Grid;

// // export default function Login() {
// //   const navigate = useNavigate();
// //   const { token } = useToken();
// //   const screens = useBreakpoint();

// //   const [isLoading, setIsLoading] = useState(false);
// //   const [messageApi, contextHolder] = message.useMessage();

// //   const onFinish = (values) => {
// //     setIsLoading(true);
// //     logIn(values)
// //       .then((res) => {
// //         if (res.status === 200) {
// //           navigate(`/login-otp/${values.email}`, { replace: true });
// //         }
// //       })
// //       .catch((err) => {
// //         const msg =
// //           err.response?.data?.message || err.message || "Server error";
// //         messageApi.open({
// //           type: "error",
// //           content: msg,
// //         });
// //       })
// //       .finally(() => setIsLoading(false));
// //   };

// //   const userDetails = Cookies.get("user_details");

// //   const styles = {
// //     section: {
// //       minHeight: "100vh",
// //       display: "flex",
// //       flexDirection: "column",
// //       justifyContent: "center", // vertical centering
// //       alignItems: "flex-end", // 👈 push card to the right
// //       background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",

// //       // 👇 SAME logic as old code
// //       padding: screens.md ? `${token.sizeXXL}px 60px` : "10px",
// //     },

// //     container: {
// //       // background: "#ffffff",
// //       background: "rgba(255, 255, 255)",
// //       borderRadius: "12px",
// //       boxShadow: "0 10px 40px rgba(0, 0, 0, 0.1)",
// //       padding: "40px",
// //       width: "420px", // fixed width is important
// //     },

// //     header: {
// //       textAlign: "center",
// //       marginBottom: "32px",
// //     },

// //     title: {
// //       fontSize: "28px",
// //       fontWeight: 700,
// //       color: "#1a202c",
// //       marginBottom: "8px",
// //     },

// //     subtitle: {
// //       fontSize: "14px",
// //       color: "#718096",
// //     },

// //     label: {
// //       fontSize: "14px",
// //       fontWeight: 600,
// //       color: "#2d3748",
// //     },

// //     input: {
// //       padding: "12px 16px",
// //       borderRadius: "8px",
// //       fontSize: "16px",
// //     },

// //     button: {
// //       height: "48px",
// //       fontSize: "16px",
// //       fontWeight: 600,
// //       borderRadius: "8px",
// //       background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
// //       border: "none",
// //     },

// //     forgotPassword: {
// //       marginTop: "16px",
// //       textAlign: "center",
// //       display: "block",
// //       color: "#667eea",
// //       fontSize: "14px",
// //       fontWeight: 500,
// //     },
// //   };

// //   return userDetails ? (
// //     <Navigate to="/" replace />
// //   ) : (
// //     <>
// //       {contextHolder}
// //       <section
// //         style={{
// //           ...styles.section,
// //           backgroundImage: `url(${process.env.PUBLIC_URL}/images/home_page_image.png)`,
// //         }}
// //       >
// //         <div style={styles.container}>
// //           {/* Header */}
// //           <div style={styles.header}>
// //             {/* <h2 style={styles.title}>Sign In</h2> */}
// //             <div
// //               style={{
// //                 textAlign: "center",
// //                 display: "flex",
// //                 width: "100%",
// //                 justifyContent: "center",
// //                 alignItems: "center",
// //               }}
// //             >
// //               <img
// //                 src={`${process.env.PUBLIC_URL}/images/step_to_innovation_logo.jpeg`}
// //                 alt="Logo"
// //                 style={{
// //                   width: "5rem",
// //                   height: "auto",
// //                   borderRadius: "50%",
// //                   marginRight: "10px",
// //                 }}
// //               />
// //               <h2>Step to Innovation</h2>
// //             </div>
// //             <p style={styles.subtitle}>
// //               Enter your credentials to login your account
// //             </p>
// //           </div>

// //           {/* Login Form */}
// //           <Form
// //             name="login_form"
// //             layout="vertical"
// //             requiredMark={false}
// //             onFinish={onFinish}
// //           >
// //             <Form.Item
// //               name="email"
// //               label={<span style={styles.label}>Email Address</span>}
// //               rules={[{ required: true, message: "Please input your email!" }]}
// //             >
// //               <Input
// //                 prefix={<UserOutlined />}
// //                 placeholder="Enter your email"
// //                 style={styles.input}
// //               />
// //             </Form.Item>

// //             <Form.Item
// //               name="password"
// //               label={<span style={styles.label}>Password</span>}
// //               rules={[
// //                 { required: true, message: "Please input your password!" },
// //               ]}
// //             >
// //               <Input.Password
// //                 prefix={<LockOutlined />}
// //                 placeholder="Enter your password"
// //                 style={styles.input}
// //               />
// //             </Form.Item>

// //             <Form.Item style={{ marginBottom: 0 }}>
// //               <Button
// //                 block
// //                 type="primary"
// //                 htmlType="submit"
// //                 style={styles.button}
// //                 disabled={isLoading}
// //                 icon={
// //                   isLoading ? (
// //                     <Spin
// //                       indicator={<SyncOutlined spin />}
// //                       style={{ color: "white" }}
// //                     />
// //                   ) : null
// //                 }
// //               >
// //                 {!isLoading && "Sign In"}
// //               </Button>
// //             </Form.Item>

// //             <Link to="/forget-password" style={styles.forgotPassword}>
// //               Forgot Password?
// //             </Link>
// //           </Form>
// //         </div>
// //       </section>
// //     </>
// //   );
// // }

// // above is with OTP login

// // below is without OTP login

// import React, { useState } from "react";
// import { Button, Form, Grid, Input, message, Spin, theme } from "antd";
// import { LockOutlined, SyncOutlined, UserOutlined } from "@ant-design/icons";
// import { Link, Navigate, useNavigate } from "react-router-dom";
// import Cookies from "js-cookie";
// import { logIn } from "../Service/login";
// import { usePermissions } from "../../context/PermissionContext";
// import { encryptAES } from "../../utils/crypto";

// const { useToken } = theme;
// const { useBreakpoint } = Grid;

// export default function Login() {
//   const navigate = useNavigate();
//   const { token } = useToken();
//   const screens = useBreakpoint();
//   const { reload } = usePermissions();

//   const [isLoading, setIsLoading] = useState(false);
//   const [messageApi, contextHolder] = message.useMessage();

//   const onFinish = async (values) => {
//     setIsLoading(true);
//     try {
//       // Encrypt the password with AES-CBC before sending —
//       // backend CryptoService.decrypt() expects: base64(iv):base64(ciphertext)
//       const encryptedPassword = await encryptAES(values.password);

//       const res = await logIn({ ...values, password: encryptedPassword });

//       // 1. Write cookies
//       const AUTH_TOKEN_EXPIRY    = new Date(Date.now() + 10 * 60 * 1000); // 10 min
//       const REFRESH_TOKEN_EXPIRY = new Date(Date.now() + 30 * 60 * 1000); // 30 min

//       Cookies.set("AUTH_TOKEN",    JSON.stringify(res.data.accessToken),  { expires: AUTH_TOKEN_EXPIRY });
//       Cookies.set("REFRESH_TOKEN", JSON.stringify(res.data.refreshToken), { expires: REFRESH_TOKEN_EXPIRY });
//       Cookies.set("user_details",  JSON.stringify(res.data.userDetails),  { expires: REFRESH_TOKEN_EXPIRY });

//       // 2. Load permissions before navigating
//       await reload();

//       // 3. Navigate
//       navigate("/", { replace: true });
//     } catch (err) {
//       const msg = err.response?.data?.message || err.message || "Server error";
//       messageApi.open({ type: "error", content: msg });
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const userDetails = Cookies.get("user_details");

//   const styles = {
//     section: {
//       minHeight: "100vh",
//       display: "flex",
//       flexDirection: "column",
//       justifyContent: "center",
//       alignItems: "flex-end",
//       background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
//       padding: screens.md ? `${token.sizeXXL}px 60px` : "10px",
//     },
//     container: {
//       background: "rgba(255, 255, 255)",
//       borderRadius: "12px",
//       boxShadow: "0 10px 40px rgba(0, 0, 0, 0.1)",
//       padding: "40px",
//       width: "420px",
//     },
//     header: {
//       textAlign: "center",
//       marginBottom: "32px",
//     },
//     title: {
//       fontSize: "28px",
//       fontWeight: 700,
//       color: "#1a202c",
//       marginBottom: "8px",
//     },
//     subtitle: {
//       fontSize: "14px",
//       color: "#718096",
//     },
//     label: {
//       fontSize: "14px",
//       fontWeight: 600,
//       color: "#2d3748",
//     },
//     input: {
//       padding: "12px 16px",
//       borderRadius: "8px",
//       fontSize: "16px",
//     },
//     button: {
//       height: "48px",
//       fontSize: "16px",
//       fontWeight: 600,
//       borderRadius: "8px",
//       background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
//       border: "none",
//     },
//     forgotPassword: {
//       marginTop: "16px",
//       textAlign: "center",
//       display: "block",
//       color: "#667eea",
//       fontSize: "14px",
//       fontWeight: 500,
//     },
//   };

//   return userDetails ? (
//     <Navigate to="/" replace />
//   ) : (
//     <>
//       {contextHolder}
//       <section
//         style={{
//           ...styles.section,
//           backgroundImage: `url(${process.env.PUBLIC_URL}/images/home_page_image.png)`,
//         }}
//       >
//         <div style={styles.container}>
//           {/* Header */}
//           <div style={styles.header}>
//             <div
//               style={{
//                 textAlign: "center",
//                 display: "flex",
//                 width: "100%",
//                 justifyContent: "center",
//                 alignItems: "center",
//               }}
//             >
//               <img
//                 src={`${process.env.PUBLIC_URL}/images/step_to_innovation_logo.jpeg`}
//                 alt="Logo"
//                 style={{
//                   width: "5rem",
//                   height: "auto",
//                   borderRadius: "50%",
//                   marginRight: "10px",
//                 }}
//               />
//               <h2>Step to Innovation</h2>
//             </div>
//             <p style={styles.subtitle}>
//               Enter your credentials to login your account
//             </p>
//           </div>

//           {/* Login Form */}
//           <Form
//             name="login_form"
//             layout="vertical"
//             requiredMark={false}
//             onFinish={onFinish}
//           >
//             <Form.Item
//               name="email"
//               label={<span style={styles.label}>Email Address</span>}
//               rules={[{ required: true, message: "Please input your email!" }]}
//             >
//               <Input
//                 prefix={<UserOutlined />}
//                 placeholder="Enter your email"
//                 style={styles.input}
//               />
//             </Form.Item>

//             <Form.Item
//               name="password"
//               label={<span style={styles.label}>Password</span>}
//               rules={[{ required: true, message: "Please input your password!" }]}
//             >
//               <Input.Password
//                 prefix={<LockOutlined />}
//                 placeholder="Enter your password"
//                 style={styles.input}
//               />
//             </Form.Item>

//             <Form.Item style={{ marginBottom: 0 }}>
//               <Button
//                 block
//                 type="primary"
//                 htmlType="submit"
//                 style={styles.button}
//                 disabled={isLoading}
//                 icon={
//                   isLoading ? (
//                     <Spin
//                       indicator={<SyncOutlined spin />}
//                       style={{ color: "white" }}
//                     />
//                   ) : null
//                 }
//               >
//                 {!isLoading && "Sign In"}
//               </Button>
//             </Form.Item>

//             <Link to="/forget-password" style={styles.forgotPassword}>
//               Forgot Password?
//             </Link>
//           </Form>
//         </div>
//       </section>
//     </>
//   );
// }

// // import React, { useState } from "react";
// // import { Button, Form, Grid, Input, message, Spin, theme } from "antd";
// // import { LockOutlined, SyncOutlined, UserOutlined } from "@ant-design/icons";
// // import { Link, Navigate, useNavigate } from "react-router-dom";
// // import Cookies from "js-cookie";
// // import { logIn } from "../Service/login";

// // const { useToken } = theme;
// // const { useBreakpoint } = Grid;

// // export default function Login() {
// //   const navigate = useNavigate();
// //   const { token } = useToken();
// //   const screens = useBreakpoint();

// //   const [isLoading, setIsLoading] = useState(false);
// //   const [messageApi, contextHolder] = message.useMessage();

// //   const onFinish = (values) => {
// //     setIsLoading(true);
// //     logIn(values)
// //       .then((res) => {
// //         if (res.status === 200) {
// //           navigate(`/login-otp/${values.email}`, { replace: true });
// //         }
// //       })
// //       .catch((err) => {
// //         const msg =
// //           err.response?.data?.message || err.message || "Server error";
// //         messageApi.open({
// //           type: "error",
// //           content: msg,
// //         });
// //       })
// //       .finally(() => setIsLoading(false));
// //   };

// //   const userDetails = Cookies.get("user_details");

// //   const styles = {
// //     section: {
// //       minHeight: "100vh",
// //       display: "flex",
// //       flexDirection: "column",
// //       justifyContent: "center", // vertical centering
// //       alignItems: "flex-end", // 👈 push card to the right
// //       background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",

// //       // 👇 SAME logic as old code
// //       padding: screens.md ? `${token.sizeXXL}px 60px` : "10px",
// //     },

// //     container: {
// //       // background: "#ffffff",
// //       background: "rgba(255, 255, 255)",
// //       borderRadius: "12px",
// //       boxShadow: "0 10px 40px rgba(0, 0, 0, 0.1)",
// //       padding: "40px",
// //       width: "420px", // fixed width is important
// //     },

// //     header: {
// //       textAlign: "center",
// //       marginBottom: "32px",
// //     },

// //     title: {
// //       fontSize: "28px",
// //       fontWeight: 700,
// //       color: "#1a202c",
// //       marginBottom: "8px",
// //     },

// //     subtitle: {
// //       fontSize: "14px",
// //       color: "#718096",
// //     },

// //     label: {
// //       fontSize: "14px",
// //       fontWeight: 600,
// //       color: "#2d3748",
// //     },

// //     input: {
// //       padding: "12px 16px",
// //       borderRadius: "8px",
// //       fontSize: "16px",
// //     },

// //     button: {
// //       height: "48px",
// //       fontSize: "16px",
// //       fontWeight: 600,
// //       borderRadius: "8px",
// //       background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
// //       border: "none",
// //     },

// //     forgotPassword: {
// //       marginTop: "16px",
// //       textAlign: "center",
// //       display: "block",
// //       color: "#667eea",
// //       fontSize: "14px",
// //       fontWeight: 500,
// //     },
// //   };

// //   return userDetails ? (
// //     <Navigate to="/" replace />
// //   ) : (
// //     <>
// //       {contextHolder}
// //       <section
// //         style={{
// //           ...styles.section,
// //           backgroundImage: `url(${process.env.PUBLIC_URL}/images/home_page_image.png)`,
// //         }}
// //       >
// //         <div style={styles.container}>
// //           {/* Header */}
// //           <div style={styles.header}>
// //             {/* <h2 style={styles.title}>Sign In</h2> */}
// //             <div
// //               style={{
// //                 textAlign: "center",
// //                 display: "flex",
// //                 width: "100%",
// //                 justifyContent: "center",
// //                 alignItems: "center",
// //               }}
// //             >
// //               <img
// //                 src={`${process.env.PUBLIC_URL}/images/step_to_innovation_logo.jpeg`}
// //                 alt="Logo"
// //                 style={{
// //                   width: "5rem",
// //                   height: "auto",
// //                   borderRadius: "50%",
// //                   marginRight: "10px",
// //                 }}
// //               />
// //               <h2>Step to Innovation</h2>
// //             </div>
// //             <p style={styles.subtitle}>
// //               Enter your credentials to login your account
// //             </p>
// //           </div>

// //           {/* Login Form */}
// //           <Form
// //             name="login_form"
// //             layout="vertical"
// //             requiredMark={false}
// //             onFinish={onFinish}
// //           >
// //             <Form.Item
// //               name="email"
// //               label={<span style={styles.label}>Email Address</span>}
// //               rules={[{ required: true, message: "Please input your email!" }]}
// //             >
// //               <Input
// //                 prefix={<UserOutlined />}
// //                 placeholder="Enter your email"
// //                 style={styles.input}
// //               />
// //             </Form.Item>

// //             <Form.Item
// //               name="password"
// //               label={<span style={styles.label}>Password</span>}
// //               rules={[
// //                 { required: true, message: "Please input your password!" },
// //               ]}
// //             >
// //               <Input.Password
// //                 prefix={<LockOutlined />}
// //                 placeholder="Enter your password"
// //                 style={styles.input}
// //               />
// //             </Form.Item>

// //             <Form.Item style={{ marginBottom: 0 }}>
// //               <Button
// //                 block
// //                 type="primary"
// //                 htmlType="submit"
// //                 style={styles.button}
// //                 disabled={isLoading}
// //                 icon={
// //                   isLoading ? (
// //                     <Spin
// //                       indicator={<SyncOutlined spin />}
// //                       style={{ color: "white" }}
// //                     />
// //                   ) : null
// //                 }
// //               >
// //                 {!isLoading && "Sign In"}
// //               </Button>
// //             </Form.Item>

// //             <Link to="/forget-password" style={styles.forgotPassword}>
// //               Forgot Password?
// //             </Link>
// //           </Form>
// //         </div>
// //       </section>
// //     </>
// //   );
// // }

// // above is with OTP login

// // below is without OTP login

// import React, { useState } from "react";
// import { Button, Form, Grid, Input, message, Spin, theme } from "antd";
// import { LockOutlined, SyncOutlined, UserOutlined } from "@ant-design/icons";
// import { Link, Navigate, useNavigate } from "react-router-dom";
// import Cookies from "js-cookie";
// import { logIn } from "../Service/login";
// import { usePermissions } from "../../context/PermissionContext";
// import { encryptAES } from "../../utils/crypto";

// const { useToken } = theme;
// const { useBreakpoint } = Grid;

// export default function Login() {
//   const navigate = useNavigate();
//   const { token } = useToken();
//   const screens = useBreakpoint();
//   const { reload } = usePermissions();

//   const [isLoading, setIsLoading] = useState(false);
//   const [messageApi, contextHolder] = message.useMessage();

//   const onFinish = async (values) => {
//     setIsLoading(true);
//     try {
//       // Encrypt the password with AES-CBC before sending —
//       // backend CryptoService.decrypt() expects: base64(iv):base64(ciphertext)
//       const encryptedPassword = await encryptAES(values.password);

//       const res = await logIn({ ...values, password: encryptedPassword });

//       // 1. Write cookies
//       const AUTH_TOKEN_EXPIRY    = new Date(Date.now() + 10 * 60 * 1000); // 10 min
//       const REFRESH_TOKEN_EXPIRY = new Date(Date.now() + 30 * 60 * 1000); // 30 min

//       Cookies.set("AUTH_TOKEN",    JSON.stringify(res.data.accessToken),  { expires: AUTH_TOKEN_EXPIRY });
//       Cookies.set("REFRESH_TOKEN", JSON.stringify(res.data.refreshToken), { expires: REFRESH_TOKEN_EXPIRY });
//       Cookies.set("user_details",  JSON.stringify(res.data.userDetails),  { expires: REFRESH_TOKEN_EXPIRY });

//       // 2. Load permissions before navigating
//       await reload();

//       // 3. Navigate
//       navigate("/", { replace: true });
//     } catch (err) {
//       const msg = err.response?.data?.message || err.message || "Server error";
//       messageApi.open({ type: "error", content: msg });
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const userDetails = Cookies.get("user_details");

//   const styles = {
//     section: {
//       minHeight: "100vh",
//       display: "flex",
//       flexDirection: "column",
//       justifyContent: "center",
//       alignItems: "flex-end",
//       background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
//       padding: screens.md ? `${token.sizeXXL}px 60px` : "10px",
//     },
//     container: {
//       background: "rgba(255, 255, 255)",
//       borderRadius: "12px",
//       boxShadow: "0 10px 40px rgba(0, 0, 0, 0.1)",
//       padding: "40px",
//       width: "420px",
//     },
//     header: {
//       textAlign: "center",
//       marginBottom: "32px",
//     },
//     title: {
//       fontSize: "28px",
//       fontWeight: 700,
//       color: "#1a202c",
//       marginBottom: "8px",
//     },
//     subtitle: {
//       fontSize: "14px",
//       color: "#718096",
//     },
//     label: {
//       fontSize: "14px",
//       fontWeight: 600,
//       color: "#2d3748",
//     },
//     input: {
//       padding: "12px 16px",
//       borderRadius: "8px",
//       fontSize: "16px",
//     },
//     button: {
//       height: "48px",
//       fontSize: "16px",
//       fontWeight: 600,
//       borderRadius: "8px",
//       background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
//       border: "none",
//     },
//     forgotPassword: {
//       marginTop: "16px",
//       textAlign: "center",
//       display: "block",
//       color: "#667eea",
//       fontSize: "14px",
//       fontWeight: 500,
//     },
//   };

//   return userDetails ? (
//     <Navigate to="/" replace />
//   ) : (
//     <>
//       {contextHolder}
//       <section
//         style={{
//           ...styles.section,
//           backgroundImage: `url(${process.env.PUBLIC_URL}/images/home_page_image.png)`,
//         }}
//       >
//         <div style={styles.container}>
//           {/* Header */}
//           <div style={styles.header}>
//             <div
//               style={{
//                 textAlign: "center",
//                 display: "flex",
//                 width: "100%",
//                 justifyContent: "center",
//                 alignItems: "center",
//               }}
//             >
//               <img
//                 src={`${process.env.PUBLIC_URL}/images/step_to_innovation_logo.jpeg`}
//                 alt="Logo"
//                 style={{
//                   width: "5rem",
//                   height: "auto",
//                   borderRadius: "50%",
//                   marginRight: "10px",
//                 }}
//               />
//               <h2>Step to Innovation</h2>
//             </div>
//             <p style={styles.subtitle}>
//               Enter your credentials to login your account
//             </p>
//           </div>

//           {/* Login Form */}
//           <Form
//             name="login_form"
//             layout="vertical"
//             requiredMark={false}
//             onFinish={onFinish}
//           >
//             <Form.Item
//               name="email"
//               label={<span style={styles.label}>Email Address</span>}
//               rules={[{ required: true, message: "Please input your email!" }]}
//             >
//               <Input
//                 prefix={<UserOutlined />}
//                 placeholder="Enter your email"
//                 style={styles.input}
//               />
//             </Form.Item>

//             <Form.Item
//               name="password"
//               label={<span style={styles.label}>Password</span>}
//               rules={[{ required: true, message: "Please input your password!" }]}
//             >
//               <Input.Password
//                 prefix={<LockOutlined />}
//                 placeholder="Enter your password"
//                 style={styles.input}
//               />
//             </Form.Item>

//             <Form.Item style={{ marginBottom: 0 }}>
//               <Button
//                 block
//                 type="primary"
//                 htmlType="submit"
//                 style={styles.button}
//                 disabled={isLoading}
//                 icon={
//                   isLoading ? (
//                     <Spin
//                       indicator={<SyncOutlined spin />}
//                       style={{ color: "white" }}
//                     />
//                   ) : null
//                 }
//               >
//                 {!isLoading && "Sign In"}
//               </Button>
//             </Form.Item>

//             <Link to="/forget-password" style={styles.forgotPassword}>
//               Forgot Password?
//             </Link>
//           </Form>
//         </div>
//       </section>
//     </>
//   );
// }

// // import React, { useState } from "react";
// // import { Button, Form, Grid, Input, message, Spin, theme } from "antd";
// // import { LockOutlined, SyncOutlined, UserOutlined } from "@ant-design/icons";
// // import { Link, Navigate, useNavigate } from "react-router-dom";
// // import Cookies from "js-cookie";
// // import { logIn } from "../Service/login";

// // const { useToken } = theme;
// // const { useBreakpoint } = Grid;

// // export default function Login() {
// //   const navigate = useNavigate();
// //   const { token } = useToken();
// //   const screens = useBreakpoint();

// //   const [isLoading, setIsLoading] = useState(false);
// //   const [messageApi, contextHolder] = message.useMessage();

// //   const onFinish = (values) => {
// //     setIsLoading(true);
// //     logIn(values)
// //       .then((res) => {
// //         if (res.status === 200) {
// //           navigate(`/login-otp/${values.email}`, { replace: true });
// //         }
// //       })
// //       .catch((err) => {
// //         const msg =
// //           err.response?.data?.message || err.message || "Server error";
// //         messageApi.open({
// //           type: "error",
// //           content: msg,
// //         });
// //       })
// //       .finally(() => setIsLoading(false));
// //   };

// //   const userDetails = Cookies.get("user_details");

// //   const styles = {
// //     section: {
// //       minHeight: "100vh",
// //       display: "flex",
// //       flexDirection: "column",
// //       justifyContent: "center", // vertical centering
// //       alignItems: "flex-end", // 👈 push card to the right
// //       background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",

// //       // 👇 SAME logic as old code
// //       padding: screens.md ? `${token.sizeXXL}px 60px` : "10px",
// //     },

// //     container: {
// //       // background: "#ffffff",
// //       background: "rgba(255, 255, 255)",
// //       borderRadius: "12px",
// //       boxShadow: "0 10px 40px rgba(0, 0, 0, 0.1)",
// //       padding: "40px",
// //       width: "420px", // fixed width is important
// //     },

// //     header: {
// //       textAlign: "center",
// //       marginBottom: "32px",
// //     },

// //     title: {
// //       fontSize: "28px",
// //       fontWeight: 700,
// //       color: "#1a202c",
// //       marginBottom: "8px",
// //     },

// //     subtitle: {
// //       fontSize: "14px",
// //       color: "#718096",
// //     },

// //     label: {
// //       fontSize: "14px",
// //       fontWeight: 600,
// //       color: "#2d3748",
// //     },

// //     input: {
// //       padding: "12px 16px",
// //       borderRadius: "8px",
// //       fontSize: "16px",
// //     },

// //     button: {
// //       height: "48px",
// //       fontSize: "16px",
// //       fontWeight: 600,
// //       borderRadius: "8px",
// //       background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
// //       border: "none",
// //     },

// //     forgotPassword: {
// //       marginTop: "16px",
// //       textAlign: "center",
// //       display: "block",
// //       color: "#667eea",
// //       fontSize: "14px",
// //       fontWeight: 500,
// //     },
// //   };

// //   return userDetails ? (
// //     <Navigate to="/" replace />
// //   ) : (
// //     <>
// //       {contextHolder}
// //       <section
// //         style={{
// //           ...styles.section,
// //           backgroundImage: `url(${process.env.PUBLIC_URL}/images/home_page_image.png)`,
// //         }}
// //       >
// //         <div style={styles.container}>
// //           {/* Header */}
// //           <div style={styles.header}>
// //             {/* <h2 style={styles.title}>Sign In</h2> */}
// //             <div
// //               style={{
// //                 textAlign: "center",
// //                 display: "flex",
// //                 width: "100%",
// //                 justifyContent: "center",
// //                 alignItems: "center",
// //               }}
// //             >
// //               <img
// //                 src={`${process.env.PUBLIC_URL}/images/step_to_innovation_logo.jpeg`}
// //                 alt="Logo"
// //                 style={{
// //                   width: "5rem",
// //                   height: "auto",
// //                   borderRadius: "50%",
// //                   marginRight: "10px",
// //                 }}
// //               />
// //               <h2>Step to Innovation</h2>
// //             </div>
// //             <p style={styles.subtitle}>
// //               Enter your credentials to login your account
// //             </p>
// //           </div>

// //           {/* Login Form */}
// //           <Form
// //             name="login_form"
// //             layout="vertical"
// //             requiredMark={false}
// //             onFinish={onFinish}
// //           >
// //             <Form.Item
// //               name="email"
// //               label={<span style={styles.label}>Email Address</span>}
// //               rules={[{ required: true, message: "Please input your email!" }]}
// //             >
// //               <Input
// //                 prefix={<UserOutlined />}
// //                 placeholder="Enter your email"
// //                 style={styles.input}
// //               />
// //             </Form.Item>

// //             <Form.Item
// //               name="password"
// //               label={<span style={styles.label}>Password</span>}
// //               rules={[
// //                 { required: true, message: "Please input your password!" },
// //               ]}
// //             >
// //               <Input.Password
// //                 prefix={<LockOutlined />}
// //                 placeholder="Enter your password"
// //                 style={styles.input}
// //               />
// //             </Form.Item>

// //             <Form.Item style={{ marginBottom: 0 }}>
// //               <Button
// //                 block
// //                 type="primary"
// //                 htmlType="submit"
// //                 style={styles.button}
// //                 disabled={isLoading}
// //                 icon={
// //                   isLoading ? (
// //                     <Spin
// //                       indicator={<SyncOutlined spin />}
// //                       style={{ color: "white" }}
// //                     />
// //                   ) : null
// //                 }
// //               >
// //                 {!isLoading && "Sign In"}
// //               </Button>
// //             </Form.Item>

// //             <Link to="/forget-password" style={styles.forgotPassword}>
// //               Forgot Password?
// //             </Link>
// //           </Form>
// //         </div>
// //       </section>
// //     </>
// //   );
// // }

// // above is with OTP login

// // below is without OTP login

// import React, { useState } from "react";
// import { Button, Form, Grid, Input, message, Spin, theme } from "antd";
// import { LockOutlined, SyncOutlined, UserOutlined } from "@ant-design/icons";
// import { Link, Navigate, useNavigate } from "react-router-dom";
// import Cookies from "js-cookie";
// import { logIn } from "../Service/login";
// import { usePermissions } from "../../context/PermissionContext";
// import { encryptAES } from "../../utils/crypto";

// const { useToken } = theme;
// const { useBreakpoint } = Grid;

// export default function Login() {
//   const navigate = useNavigate();
//   const { token } = useToken();
//   const screens = useBreakpoint();
//   const { reload } = usePermissions();

//   const [isLoading, setIsLoading] = useState(false);
//   const [messageApi, contextHolder] = message.useMessage();

//   const onFinish = async (values) => {
//     setIsLoading(true);
//     try {
//       // Encrypt the password with AES-CBC before sending —
//       // backend CryptoService.decrypt() expects: base64(iv):base64(ciphertext)
//       const encryptedPassword = await encryptAES(values.password);

//       const res = await logIn({ ...values, password: encryptedPassword });

//       // 1. Write cookies
//       const AUTH_TOKEN_EXPIRY    = new Date(Date.now() + 10 * 60 * 1000); // 10 min
//       const REFRESH_TOKEN_EXPIRY = new Date(Date.now() + 30 * 60 * 1000); // 30 min

//       Cookies.set("AUTH_TOKEN",    JSON.stringify(res.data.accessToken),  { expires: AUTH_TOKEN_EXPIRY });
//       Cookies.set("REFRESH_TOKEN", JSON.stringify(res.data.refreshToken), { expires: REFRESH_TOKEN_EXPIRY });
//       Cookies.set("user_details",  JSON.stringify(res.data.userDetails),  { expires: REFRESH_TOKEN_EXPIRY });

//       // 2. Load permissions before navigating
//       await reload();

//       // 3. Navigate
//       navigate("/", { replace: true });
//     } catch (err) {
//       const msg = err.response?.data?.message || err.message || "Server error";
//       messageApi.open({ type: "error", content: msg });
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const userDetails = Cookies.get("user_details");

//   const styles = {
//     section: {
//       minHeight: "100vh",
//       display: "flex",
//       flexDirection: "column",
//       justifyContent: "center",
//       alignItems: "flex-end",
//       background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
//       padding: screens.md ? `${token.sizeXXL}px 60px` : "10px",
//     },
//     container: {
//       background: "rgba(255, 255, 255)",
//       borderRadius: "12px",
//       boxShadow: "0 10px 40px rgba(0, 0, 0, 0.1)",
//       padding: "40px",
//       width: "420px",
//     },
//     header: {
//       textAlign: "center",
//       marginBottom: "32px",
//     },
//     title: {
//       fontSize: "28px",
//       fontWeight: 700,
//       color: "#1a202c",
//       marginBottom: "8px",
//     },
//     subtitle: {
//       fontSize: "14px",
//       color: "#718096",
//     },
//     label: {
//       fontSize: "14px",
//       fontWeight: 600,
//       color: "#2d3748",
//     },
//     input: {
//       padding: "12px 16px",
//       borderRadius: "8px",
//       fontSize: "16px",
//     },
//     button: {
//       height: "48px",
//       fontSize: "16px",
//       fontWeight: 600,
//       borderRadius: "8px",
//       background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
//       border: "none",
//     },
//     forgotPassword: {
//       marginTop: "16px",
//       textAlign: "center",
//       display: "block",
//       color: "#667eea",
//       fontSize: "14px",
//       fontWeight: 500,
//     },
//   };

//   return userDetails ? (
//     <Navigate to="/" replace />
//   ) : (
//     <>
//       {contextHolder}
//       <section
//         style={{
//           ...styles.section,
//           backgroundImage: `url(${process.env.PUBLIC_URL}/images/home_page_image.png)`,
//         }}
//       >
//         <div style={styles.container}>
//           {/* Header */}
//           <div style={styles.header}>
//             <div
//               style={{
//                 textAlign: "center",
//                 display: "flex",
//                 width: "100%",
//                 justifyContent: "center",
//                 alignItems: "center",
//               }}
//             >
//               <img
//                 src={`${process.env.PUBLIC_URL}/images/step_to_innovation_logo.jpeg`}
//                 alt="Logo"
//                 style={{
//                   width: "5rem",
//                   height: "auto",
//                   borderRadius: "50%",
//                   marginRight: "10px",
//                 }}
//               />
//               <h2>Step to Innovation</h2>
//             </div>
//             <p style={styles.subtitle}>
//               Enter your credentials to login your account
//             </p>
//           </div>

//           {/* Login Form */}
//           <Form
//             name="login_form"
//             layout="vertical"
//             requiredMark={false}
//             onFinish={onFinish}
//           >
//             <Form.Item
//               name="email"
//               label={<span style={styles.label}>Email Address</span>}
//               rules={[{ required: true, message: "Please input your email!" }]}
//             >
//               <Input
//                 prefix={<UserOutlined />}
//                 placeholder="Enter your email"
//                 style={styles.input}
//               />
//             </Form.Item>

//             <Form.Item
//               name="password"
//               label={<span style={styles.label}>Password</span>}
//               rules={[{ required: true, message: "Please input your password!" }]}
//             >
//               <Input.Password
//                 prefix={<LockOutlined />}
//                 placeholder="Enter your password"
//                 style={styles.input}
//               />
//             </Form.Item>

//             <Form.Item style={{ marginBottom: 0 }}>
//               <Button
//                 block
//                 type="primary"
//                 htmlType="submit"
//                 style={styles.button}
//                 disabled={isLoading}
//                 icon={
//                   isLoading ? (
//                     <Spin
//                       indicator={<SyncOutlined spin />}
//                       style={{ color: "white" }}
//                     />
//                   ) : null
//                 }
//               >
//                 {!isLoading && "Sign In"}
//               </Button>
//             </Form.Item>

//             <Link to="/forget-password" style={styles.forgotPassword}>
//               Forgot Password?
//             </Link>
//           </Form>
//         </div>
//       </section>
//     </>
//   );
// }

import React, { useEffect, useState } from "react";
import { Button, Form, Grid, Input, message, Spin, theme, Modal } from "antd";
import { LockOutlined, SyncOutlined, UserOutlined, WarningOutlined } from "@ant-design/icons";
import { Link, Navigate, useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { Client } from "@stomp/stompjs";
import SockJS from "sockjs-client";
import { logIn } from "../Service/login";
import { forceSession } from "../../AssetMonitoringSystem/module/writecontrole/service/Writecontrol";
import { usePermissions } from "../../context/PermissionContext";
import { encryptAES } from "../../utils/crypto";

const { useToken } = theme;
const { useBreakpoint } = Grid;

const wsUrl = (process.env.REACT_APP_API || "https://localhost:8081").replace(/\/api$/, "");

export default function Login() {
  const navigate = useNavigate();
  const { token } = useToken();
  const screens = useBreakpoint();
  const { reload } = usePermissions();

  const [isLoading, setIsLoading] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();

  // Challenge state
  const [challengeVisible, setChallengeVisible]   = useState(false);
  const [challengeData, setChallengeData]         = useState(null); // full login response
  const [challengeLoading, setChallengeLoading]   = useState(false);
  const [waitingForApproval, setWaitingForApproval] = useState(false);
  const [forceCountdown, setForceCountdown]         = useState(30); // seconds before "Login Anyway" enables
  const [forcingLogin, setForcingLogin]             = useState(false);
  const stompRef = React.useRef(null);

  // Cleanup STOMP on unmount
  useEffect(() => () => { stompRef.current?.deactivate(); }, []);

  // Countdown timer — starts when challenge modal opens
  useEffect(() => {
    if (!waitingForApproval) return;
    setForceCountdown(30);
    const timer = setInterval(() => {
      setForceCountdown(prev => {
        if (prev <= 1) { clearInterval(timer); return 0; }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, [waitingForApproval]);

  const handleForceLogin = async () => {
    if (!challengeData) return;
    setForcingLogin(true);
    try {
      await forceSession(challengeData.sessionId);
      stompRef.current?.deactivate();
      setChallengeVisible(false);
      setWaitingForApproval(false);
      setForceCountdown(30);
      await saveSessionAndLogin(challengeData, challengeData.sessionId);
    } catch (err) {
      messageApi.error("Force login failed: " + (err?.response?.data?.message || err.message));
    } finally {
      setForcingLogin(false);
    }
  };

  const saveSessionAndLogin = async (data, sessionId) => {
    const AUTH_TOKEN_EXPIRY    = new Date(Date.now() + 10 * 60 * 1000);
    const REFRESH_TOKEN_EXPIRY = new Date(Date.now() + 30 * 60 * 1000);
    Cookies.set("AUTH_TOKEN",    JSON.stringify(data.accessToken),  { expires: AUTH_TOKEN_EXPIRY });
    Cookies.set("REFRESH_TOKEN", JSON.stringify(data.refreshToken), { expires: REFRESH_TOKEN_EXPIRY });
    Cookies.set("user_details",  JSON.stringify(data.userDetails),  { expires: REFRESH_TOKEN_EXPIRY });
    Cookies.set("SESSION_ID",    sessionId,                         { expires: REFRESH_TOKEN_EXPIRY });
    await reload();
    navigate("/", { replace: true });
  };

  const subscribeToSessionChannel = (sessionId, loginData) => {
    const client = new Client({
      webSocketFactory: () => new SockJS(`${wsUrl}/api/ws`),
      reconnectDelay: 3000,
      onConnect: () => {
        client.subscribe(`/topic/session/${sessionId}`, async (msg) => {
          const payload = JSON.parse(msg.body);
          if (payload.type === "LOGIN_ACCEPTED") {
            // Existing user accepted — we can now log in
            stompRef.current?.deactivate();
            setChallengeVisible(false);
            setWaitingForApproval(false);
            await saveSessionAndLogin(loginData, sessionId);
          } else if (payload.type === "LOGIN_REJECTED") {
            stompRef.current?.deactivate();
            setChallengeVisible(false);
            setWaitingForApproval(false);
            setIsLoading(false);
            messageApi.error("Your login was rejected by the active user.");
          }
        });
      },
    });
    client.activate();
    stompRef.current = client;
  };

  const onFinish = async (values) => {
    setIsLoading(true);
    try {
      const encryptedPassword = await encryptAES(values.password);
      const res = await logIn({ ...values, password: encryptedPassword });
      const data = res.data;

      if (data.challenged) {
        // Another session exists — show challenge flow
        setChallengeData(data);
        setChallengeVisible(true);
        setWaitingForApproval(true);
        setIsLoading(false);
        // Subscribe to our sessionId channel to receive accept/reject
        subscribeToSessionChannel(data.sessionId, data);
      } else {
        await saveSessionAndLogin(data, data.sessionId);
      }
    } catch (err) {
      const msg = err.response?.data?.message || err.message || "Login failed";
      messageApi.error(msg);
      setIsLoading(false);
    }
  };

  const userDetails = Cookies.get("user_details");

  const styles = {
    section: {
      minHeight: "100vh",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "flex-end",
      padding: screens.md ? `${token.sizeXXL}px 60px` : "10px",
    },
    container: {
      background: "#fff",
      borderRadius: "12px",
      boxShadow: "0 10px 40px rgba(0,0,0,0.1)",
      padding: "40px",
      width: "420px",
    },
    button: {
      height: "48px",
      fontSize: "16px",
      fontWeight: 600,
      borderRadius: "8px",
      background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
      border: "none",
    },
  };

  return userDetails ? (
    <Navigate to="/" replace />
  ) : (
    <>
      {contextHolder}

      {/* ── Challenge Modal ─────────────────────────────────────────────── */}
      <Modal
        open={challengeVisible}
        footer={null}
        closable={false}
        centered
        width={420}
      >
        <div style={{ textAlign: "center", padding: "8px 0" }}>
          <WarningOutlined style={{ fontSize: 48, color: "#fa8c16", marginBottom: 16 }} />
          <h3 style={{ margin: "0 0 8px" }}>Active Session Detected</h3>
          <p style={{ color: "#666", marginBottom: 24 }}>
            Your account is already logged in on another device.<br />
            A request has been sent to the active session.
          </p>

          {waitingForApproval ? (
            <div>
              <Spin tip="Waiting for the active session to respond..." />
              <p style={{ color: "#999", fontSize: 12, marginTop: 16 }}>
                The other device will see a prompt asking to allow your login.
              </p>
              <p style={{ color: "#bbb", fontSize: 11, marginTop: 8 }}>
                If no response in 30 seconds, you can log in anyway.
              </p>
              <div style={{ display: "flex", gap: 10, justifyContent: "center", marginTop: 16 }}>
                <Button
                  onClick={() => {
                    stompRef.current?.deactivate();
                    setChallengeVisible(false);
                    setWaitingForApproval(false);
                    setIsLoading(false);
                    setForceCountdown(30);
                  }}
                >
                  Cancel
                </Button>
                <Button
                  danger
                  disabled={forceCountdown > 0}
                  loading={forcingLogin}
                  onClick={handleForceLogin}
                >
                  {forceCountdown > 0
                    ? `Login Anyway (${forceCountdown}s)`
                    : "Login Anyway"}
                </Button>
              </div>
            </div>
          ) : null}
        </div>
      </Modal>

      {/* ── Login Form ──────────────────────────────────────────────────── */}
      <section
        style={{
          ...styles.section,
          backgroundImage: `url(${process.env.PUBLIC_URL}/images/home_page_image.png)`,
        }}
      >
        <div style={styles.container}>
          <div style={{ textAlign: "center", marginBottom: 32 }}>
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", marginBottom: 8 }}>
              <img
                src={`${process.env.PUBLIC_URL}/images/step_to_innovation_logo.jpeg`}
                alt="Logo"
                style={{ width: "5rem", height: "auto", borderRadius: "50%", marginRight: 10 }}
              />
              <h2 style={{ margin: 0 }}>Step to Innovation</h2>
            </div>
            <p style={{ color: "#718096", fontSize: 14 }}>Enter your credentials to login</p>
          </div>

          <Form name="login_form" layout="vertical" requiredMark={false} onFinish={onFinish}>
            <Form.Item name="email" label="Email Address" rules={[{ required: true }]}>
              <Input prefix={<UserOutlined />} placeholder="Enter your email" style={{ height: 48 }} />
            </Form.Item>

            <Form.Item name="password" label="Password" rules={[{ required: true }]}>
              <Input.Password prefix={<LockOutlined />} placeholder="Enter your password" style={{ height: 48 }} />
            </Form.Item>

            <Form.Item style={{ marginBottom: 0 }}>
              <Button block type="primary" htmlType="submit" style={styles.button} disabled={isLoading}
                icon={isLoading ? <Spin indicator={<SyncOutlined spin />} style={{ color: "#fff" }} /> : null}>
                {!isLoading && "Sign In"}
              </Button>
            </Form.Item>

            <Link to="/forget-password" style={{ display: "block", textAlign: "center", marginTop: 16, color: "#667eea" }}>
              Forgot Password?
            </Link>
          </Form>
        </div>
      </section>
    </>
  );
}